import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { Option } from "../../Show/types";
import { MultiSelectAutocomplete } from "@components/FormsV2/MultiSelectAutoComplete";
import TagsField from "@components/FormsV2/TagsField";

const TeamsTags = ({ service, setService, teams, permission }) => {
  const [teamOptions, setTeamOptions] = useState<Option[]>([]);

  useEffect(() => {
    if (teams.length !== teamOptions.length) {
      setTeamOptions(teams);
    }
  }, [teams]);

  return (
    <div className="teamsTags">
      <Row>
        <Col sm={6}>
          <h5 className="teamsTagsHeader">Assigned Teams</h5>
          <MultiSelectAutocomplete
            label="Search Teams"
            placeholder="Search by team name or select from list"
            id="serviceTeams"
            options={teamOptions}
            value={service?.teams || []}
            onChange={(e) =>
              //@ts-ignore
              setService({ ...service, teams: e })
            }
            isDisabled={permission !== "manage"}
          />
        </Col>
        <Col sm={6}>
          <h5 className="teamsTagsHeader">Assigned Tags</h5>
          <TagsField
            id="serviceTags"
            value={(service?.tags || []).map((t: Option) => t.label)}
            onChange={(names) =>
              setService({
                ...service,
                tags: names.map((n) => ({ label: n, value: n })),
              })
            }
            isDisabled={permission !== "manage"}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TeamsTags;
